import SourceFlowText from "@sourceflow-uk/sourceflowtext"
import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import {
    Container,
    Row,
    Col,
    Card,
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem,
} from 'reactstrap';
import styles from './styles.module.scss';
import Link from "next/link"
import React, { useState } from 'react';

export default function AllSolutions({
    global,
    pathPrefix,
    customClass = "",
    post,
    buttonTitle
}) {
    const [open, setOpen] = useState('');
    const toggle = (id) => {
        if (open === id) {
            setOpen();
        } else {
            setOpen(id);
        }
    };

    return (
        post?.length >= 1 && (
            <section className={`${styles.root} ${customClass}`}>
                <Container>
                    {post?.map((post, index) => (
                        <Card key={index} className="border-0 mb-5 pb-mb-5" id={`${post.url_slug}`}>
                            <Row>
                                <Col md={8} className="pt-4">
                                    <p className="post-title fs-4"><strong>{post?.title}</strong></p>
                                    {post?.us_short_description ?
                                        <div className="post-short-description" dangerouslySetInnerHTML={{ __html: post?.us_short_description }} />
                                        : null}
                                    <Accordion open={open} toggle={toggle} flush>
                                        {post?.us_faq_content_1 ?
                                            <AccordionItem>
                                                <AccordionHeader targetId={`1-${index}`}><strong>{post?.us_faq_title_1}</strong></AccordionHeader>
                                                <AccordionBody accordionId={`1-${index}`}>
                                                    {post?.us_faq_content_1 ?
                                                        <div className="" dangerouslySetInnerHTML={{ __html: post?.us_faq_content_1 }} />
                                                        : null}
                                                </AccordionBody>
                                            </AccordionItem> : null}
                                        {post?.us_faq_content_2 ?
                                            <AccordionItem>
                                                <AccordionHeader targetId={`2-${index}`}><strong>{post?.us_faq_title_2}</strong></AccordionHeader>
                                                <AccordionBody accordionId={`2-${index}`}>
                                                    {post?.us_faq_content_1 ?
                                                        <div className="" dangerouslySetInnerHTML={{ __html: post?.us_faq_content_2 }} />
                                                        : null}
                                                </AccordionBody>
                                            </AccordionItem> : null}
                                        {post?.us_faq_content_3 ?
                                            <AccordionItem>
                                                <AccordionHeader targetId={`3-${index}`}><strong>{post?.us_faq_title_3}</strong></AccordionHeader>
                                                <AccordionBody accordionId={`3-${index}`}>
                                                    {post?.us_faq_content_3 ?
                                                        <div className="" dangerouslySetInnerHTML={{ __html: post?.us_faq_content_3 }} />
                                                        : null}
                                                </AccordionBody>
                                            </AccordionItem> : null}
                                        {post?.us_faq_content_4 ?
                                            <AccordionItem>
                                                <AccordionHeader targetId={`4-${index}`}><strong>{post?.us_faq_title_2}</strong></AccordionHeader>
                                                <AccordionBody accordionId={`4-${index}`}>
                                                    {post?.us_faq_content_4 ?
                                                        <div className="" dangerouslySetInnerHTML={{ __html: post?.us_faq_content_4 }} />
                                                        : null}
                                                </AccordionBody>
                                            </AccordionItem> : null}
                                        {post?.us_faq_content_5 ?
                                            <AccordionItem>
                                                <AccordionHeader targetId={`5-${index}`}><strong>{post?.us_faq_title_2}</strong></AccordionHeader>
                                                <AccordionBody accordionId={`5-${index}`}>
                                                    {post?.us_faq_content_5 ?
                                                        <div className="" dangerouslySetInnerHTML={{ __html: post?.us_faq_content_5 }} />
                                                        : null}
                                                </AccordionBody>
                                            </AccordionItem> : null}
                                    </Accordion>
                                    <div className="mt-4">
                                        <Link href={`/business-solutions/${post.url_slug}/`}>
                                            <a className="primaryBtn no-arrow">
                                                {buttonTitle}
                                            </a>
                                        </Link>
                                    </div>
                                </Col>

                                <Col md={4}>
                                    <SourceFlowImage
                                        src={post.image ? post.image : "/site-assets/placeholders/img-placeholder.jpg"}
                                        size="800x800"
                                        alt={post?.title}
                                        className="card-img rounded-4"
                                    />
                                </Col>

                            </Row>
                        </Card>
                    ))}
                </Container>
            </section >
        )
    )
}